var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('BannerComponent'),_c('Cursos'),_c('Redes'),_c('Footer'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wsp"},[_c('a',{attrs:{"href":"https://api.whatsapp.com/send?phone=1532528163","target":"_blank"}},[_c('img',{attrs:{"src":"/wspp.png","alt":"WhatsApp"}})])])
}]

export { render, staticRenderFns }